import { EventHandler } from 'app/interface';
import { HtmlId } from '../enum';
import { IValidation, validateFormField } from '@vfde-brix/ws10/validation';
import { createFormElement, FormElement } from '@vfde-brix/ws10/form-element';
import { mountComponent } from '../util/mount';
import { Address, toAddressString } from '@vfde-sails/avc-core';

export const mountFormElement = (wrapperId: HtmlId, handler: EventHandler, validation?: IValidation[]) =>
    mountComponent(wrapperId, createFormElement, {
        onInput: (_: Event, value: string) => handler(value),
        onChange: (_: Event, value: string) => handler(value),
        validation,
    });

/**
 * Update a FormElement which is of type 'select' with new items
 * @param {FormElement | null} comp - the FormElement to update
 * @param {Address[]} addresses - array of Addresses to convert into new items
 */
export const updateSelectFormElement = (comp: FormElement | null, addresses: Address[] = []) => {
    if (!comp) {
        return;
    }

    const props = comp.getProperties();

    if ('select' !== props.containerInput.optType) {
        return;
    }

    props.containerInput.items = addresses.map((address, index) => ({
        stdOptionLabel: toAddressString(address, true),
        stdOptionValue: index.toString(),
    }));

    comp.update(props);
};

/**
 * Update a FormElement whose type is 'text' with a new value
 * @param {FormSuggestInput | null} comp - the FormSuggestInput to update
 * @param {string} value - new input value
 * @param {boolean} shouldValidate - run the validation or not (E.g. dont validate on delete address)
 */
export const updateTextFormElement = (
    comp: FormElement | null,
    value: string,
    shouldValidate: boolean,
) => {
    const input = comp?.getContainerElement().getElementsByTagName('input')[0];

    if (!input) {
        return;
    }

    input.value = value;

    if (shouldValidate) {
        validateFormField(comp);
    }
};
